import React from 'react';
import { formatCurrency } from '../../../lib/helpers/formatters';

const TotalTr = ({ totals = {}, profileType = '' }) => {
  const { reserveTotals = 0, amountTotals = 0 } = totals;

  return (
    <tr className="summary-tr">
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td className="txt-table-right">{formatCurrency(reserveTotals)}</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      {!['SUPPLIER_INS'].includes(profileType) && <td>-</td>}
      {!['SUPPLIER_INS'].includes(profileType) && <td>-</td>}
      <td>-</td>
      <td>-</td>
      <td className="txt-table-right">{formatCurrency(amountTotals)}</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
    </tr>
  );
};

export default TotalTr;
